<template lang="pug">
div
  v-container.pa-0
    v-row( justify='center' align='start' )  
      v-col( cols=12 md=6).px-10
        v-row
          v-col(md=8)
            h1.font-weight-bold.azul--text.icono-international.icono-grande( style='position: relative' v-html='Nosotros.cuerpo.historia.titulo').pt-7.pl-7.mb-10    
          v-col(lg=10)
            p.text-justify.font-weight-regular.my-5 {{ Nosotros.cuerpo.historia.texto }}
            p.text-justify.font-weight-regular {{ Nosotros.cuerpo.historia.texto2 }}



      v-col( cols=12 md=6).red.darken-3.pa-8
        v-row.justify-center
          
          v-col(lg=10)
            
            v-row.justify-center
              h1.pl-4.pt-2.text-center.font-weight-black.white--text.my-12.icono-international.icono-blanco {{ Nosotros.cuerpo.mision.titulo }}
              p.text-justify.font-weight-regular.white--text.pa-4 {{ Nosotros.cuerpo.vision.texto }}
            v-row.justify-center
              h1.pl-4.pt-2.text-center.font-weight-black.white--text.my-12.icono-international.icono-blanco {{ Nosotros.cuerpo.vision.titulo }}
              p.text-justify.font-weight-regular.white--text {{ Nosotros.cuerpo.mision.texto }}
      
      
       

  v-container.pa-4.my-12.white
      v-row( justify='start' align='center' )
        v-col(xs=12 sm=7 md=3 xl=4)
          p.title.font-weight-black.azul--text.icono-international.icono-grande( style='position: relative' v-html='Nosotros.cuerpo.titulo_rubro').pt-6.pl-7.mb-10  

          
      v-row( justify='center' align='center' ).fill-height
        //- .d-none.d-md-block
        template( v-for='{titulo, icono} of Nosotros.cuerpo.rubros' )
          v-col( ).my-5
            v-card(tile flat :to='{name: "productos"}')
              v-row(justify='space-around')
                v-avatar.red( color='rojo' size='100'  ).d-none.d-md-block
                  v-img(:src='icono' contain)
                v-avatar.red( color='rojo' size='90'  ).my-2.mx-4.d-md-none
                  v-img(:src='icono' contain)
              v-row( justify='center' align='center' )
                v-card( color='transparent' height=10 flat )
                  h3.text-center.font-weight-bold.py-4.azul--text {{titulo}}

      







      //- v-row( justify='center' align='center' ).fill-height
      //-     v-col.d-none.d-md-flex( cols=8)( justify='center' align='center' )
      //-         v-card( color='transparent' height=10 flat ).pa-2
      //-             h1.font-weight-light {{ Construccion.texto }}
      //- v-row( justify='center' align='center' ).fill-height
      //-     v-col( cols=6).d-none.d-md-flex
      //-       v-img(:src='Construccion.imagen').fill-height
      //-     v-container
      //-       h1.font-weight-light.d-none.d-md-flex Faltan {{avance}} 
      //-       v-progress-linear(buffer-value="0" stream color='#ff0000' v-model='numero').d-none.d-md-flex
      //-     v-col( cols=7).d-md-none
      //-     v-card( color='transparent' height=10 flat ).pa-2.d-md-none
      //-       h3.d-md-none.text-center.font-weight-light {{ Construccion.texto }}
      //-         v-img(:src='Construccion.imagen' ).d-md-none 
      //-       v-container
      //-         h3.font-weight-light.d-md-none Faltan {{avance}} 
      //-         v-progress-linear(buffer-value="0" stream color='#ff0000' v-model='numero').d-md-none
          
                


  </template>

<script>
import  moment from 'moment'
export default {
  data:  ()=>({
    inicio: '29/05/2020',
    fin: '5/06/2020',
    avance: null,
    numero: 100 
  }),
  computed: {
    Construccion() {
      return this.$contenido.Construccion || {}
    },
    Nosotros() {
      return this.$contenido.Nosotros || {}
    },
  },
  created() {
    setInterval( ()=>{
      let t=moment.duration( moment(this.fin, 'DD/MM/YYYY').subtract(moment()))
      this.avance = `${t.days()} día, ${t.hours()}: ${t.minutes()}:${t.seconds()}`
      const total = moment.duration( moment(this.fin, 'DD/MM/YYYY').subtract(moment(this.inicio,'DD/MM/YYYY')))
      this.numero = total.asSeconds()/ t.asSeconds()}, 1000)
    
	
    }
  
}
</script>